export default "__VITE_ASSET__C$fE81Dw__"